import { actionable } from '@github/catalyst/lib/actionable'

export default actionable(class extends HTMLElement {
  connectedCallback () {
    document.body.classList.add('overflow-hidden')

    document.addEventListener('keyup', this.onEscKey)

    document.addEventListener('turbo:before-cache', this.close)

    if (this.dataset.closeAfterSubmit !== 'false') {
      document.addEventListener('turbo:submit-end', this.onSubmit)
    }

    // Smooth entry transition
    this.classList.add('opacity-0')
    requestAnimationFrame(() => {
      this.classList.remove('opacity-0')
      this.classList.add('opacity-100')
      const modalBox = this.querySelector('.modal-box') || this.querySelector('.relative.z-10')
      if (modalBox) {
        modalBox.classList.add('scale-95')
        requestAnimationFrame(() => {
          modalBox.classList.remove('scale-95')
          modalBox.classList.add('scale-100')
        })
      }
    })
  }

  disconnectedCallback () {
    document.body.classList.remove('overflow-hidden')

    document.removeEventListener('keyup', this.onEscKey)
    document.removeEventListener('turbo:submit-end', this.onSubmit)
    document.removeEventListener('turbo:before-cache', this.close)
  }

  onSubmit = (e) => {
    if (e.detail.success && e.detail?.formSubmission?.formElement?.dataset?.closeOnSubmit !== 'false') {
      this.close()
    }
  }

  onEscKey = (e) => {
    if (e.code === 'Escape') {
      if (this.dataset.backdropClose === 'false') return
      this.close()
    }
  }

  close = (e) => {
    e?.preventDefault()

    if (e?.target?.dataset?.backdropClose === 'false' || (e?.type === 'click' && this.dataset.backdropClose === 'false' && e?.target?.hasAttribute('data-action'))) {
      return
    }

    this.classList.remove('opacity-100')
    this.classList.add('opacity-0')
    const modalBox = this.querySelector('.modal-box') || this.querySelector('.relative.z-10')
    if (modalBox) {
      modalBox.classList.remove('scale-100')
      modalBox.classList.add('scale-95')
    }

    setTimeout(() => {
      this.remove()
    }, 150)
  }
})
